"use strict";

exports.__esModule = true;
exports.DebouncedSearchInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _Translator = require("../Translator");
var _excluded = ["value", "onChange", "style", "debounceDuration"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DebouncedSearchInput = exports.DebouncedSearchInput = function DebouncedSearchInput(props) {
  var _useState = (0, _react.useState)(function () {
      return new _rxjs.Subject();
    }),
    subject = _useState[0];
  var value = props.value,
    onChange = props.onChange,
    style = props.style,
    debounceDuration = props.debounceDuration,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var _useState2 = (0, _react.useState)(value || ""),
    innerStateValue = _useState2[0],
    setInnerStateValue = _useState2[1];
  var translator = _react["default"].useContext(_Translator.TranslatorContext);
  // Compare against the last value sent, not the mount-time prop, so clearing back to "" is forwarded.
  var lastEmittedRef = (0, _react.useRef)(value || "");
  var onChangeRef = (0, _react.useRef)(onChange);
  onChangeRef.current = onChange;
  (0, _react.useEffect)(function () {
    var subscription = subject.pipe((0, _operators.debounceTime)(debounceDuration || 150)).subscribe({
      next: function next(newValue) {
        if (newValue === lastEmittedRef.current) {
          return;
        }
        lastEmittedRef.current = newValue;
        if (onChangeRef.current) {
          onChangeRef.current(newValue);
        }
      }
    });
    return function () {
      return subscription.unsubscribe();
    };
  }, [subject, debounceDuration]);
  (0, _react.useEffect)(function () {
    subject.next(innerStateValue);
  }, [innerStateValue]);
  var handleChange = function handleChange(event) {
    setInnerStateValue(event.target.value);
  };
  return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
    style: style,
    placeholder: translator.translate("SearchInput.placeholder", "Search"),
    value: innerStateValue,
    onChange: handleChange,
    leftIcon: _icons.IconNames.SEARCH
  }, extra));
};